// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'thumbs-up';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M4.032 6.336H.648v10.152h3.384zm0 9c3.384 0 3.672 1.368 8.28 1.656 1.296.072 2.232.144 3.096-.936 1.872-2.448 2.808-8.208.936-8.208H12.6c-.864 0-1.512-.648-1.512-1.512V3.384c0-2.232-3.312-3.456-3.312-.936 0 1.8-.72 3.096-1.872 4.176-.576.504-1.152.864-1.872 1.008'
  />
);

export const viewBox = '0 0 18 18';
